import type { AdminBillingManager, AdminCompanyRow } from '@/state/useAdminBilling';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { BILLING_MODES } from 'definitions';
import { cn } from 'helpers/cn';
import { FIELD_CONTROL } from '../../Dashboard/ConsolePanel';

type BillingModeControlProps = { company: AdminCompanyRow; manager: AdminBillingManager };

export const MODE_LABEL: Record<string, string> = { card: 'Card', free: 'Free', invoice: 'Invoice' };

/**
 * The row's mode picker. It only asks for the change; whether that change needs
 * a confirm first (leaving card with a live subscription, or moving to card) is
 * decided in useAdminBilling, and the one confirm dialog is the screen's.
 *
 * Built on the shadcn primitives rather than the shared `Select`, which has no
 * way to name its trigger: a column of identical unlabelled dropdowns gives a
 * screen reader nothing to tell one company's from the next.
 */
export const BillingModeControl = ({ company, manager }: BillingModeControlProps) => (
  <Select
    value={company.billingMode}
    onValueChange={(mode) => manager.requestModeChange(company, mode)}
    disabled={manager.isChangingMode}
  >
    <SelectTrigger aria-label={`Billing mode for ${company.name}`} className={cn(FIELD_CONTROL, 'h-8 w-28')}>
      <SelectValue />
    </SelectTrigger>
    <SelectContent>
      {BILLING_MODES.map((mode) => (
        <SelectItem key={mode} value={mode}>
          {MODE_LABEL[mode] ?? mode}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);
